enum RolesEnum {
    Authenticated = 'AUTHENTICATED',
    Unauthenticated = 'UNAUTHENTICATED',
}

export default RolesEnum;
